import { useParams } from 'react-router-dom';

import JobCrmAnalytics from '../jobsCrmAnalytics/JobCrmAnalytics';

type JobCRMPageParams = {
  jobId: string;
  jobCode?: string;
};
const JobsCrmInsights = () => {
  const params = useParams<JobCRMPageParams>();
  const jobId = params.jobId ?? '';

  return <JobCrmAnalytics jobId={jobId} />;
};
export default JobsCrmInsights;
